import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  /* margin: 20px auto; */
  position: relative;
  padding: 0;
  height: 100%;
  /* border: 1px solid #eee; */
  /* border-radius: 10px; */
  /* @media (min-width: 769px) {
    height: 500px;
    width: 800px;
    margin: 0 auto;
  } */
`;
